module.exports = __webpack_public_path__ + "static/img/female-bg-pt.5119d9e6.png";